<template>
    <CSidebar fixed
              :minimize="minimize"
              :show="show"
              @update:show="(value) => $store.commit('set', ['sidebarShow', value])">
        <CSidebarBrand class="d-md-down-none" to="/">
            <img src="img/amsys2-logo-wb.png" style="max-width:12em; text-align:left;">
            <!--<CIcon class="c-sidebar-brand-full"
               name="logo"
               size="custom-size"
               :height="35"
               viewBox="0 0 556 134" />
        <CIcon class="c-sidebar-brand-minimized"
               name="logo"
               size="custom-size"
               :height="35"
               viewBox="0 0 110 134" />-->
        </CSidebarBrand>
        <CRenderFunction flat :content-to-render="$options.nav" />
        <!--<CSidebarMinimizer class="d-md-down-none"
                           @click.native="$store.commit('set', ['sidebarMinimize', !minimize])" />-->
    </CSidebar>
</template>
<script>
    import nav from './_nav'
    import Vue from 'vue';
    import axios from "axios";
    import '@babel/polyfill';
    import VueCordova from 'vue-cordova';
    Vue.use(VueCordova);
    export default {
        name: 'TheSidebar',
        nav,
        computed: {
            show() {
                return this.$store.state.sidebarShow
            },
            minimize() {
                return this.$store.state.sidebarMinimize
            }
        },
    }
</script>
